import { type PreParsedSectionSettingProps, type SectionDisplay } from '@capsicum/common';
import { useMemo } from 'react';

export const useFilterOtherSection = (section: PreParsedSectionSettingProps, isDisplayMap: SectionDisplay) => {
	const modifiedItems = useMemo(
		() =>
			section.items.filter(subItem => {
				if (subItem.action && typeof isDisplayMap[subItem.action] === 'boolean') {
					return isDisplayMap[subItem.action];
				}

				return true;
			}),
		[isDisplayMap, section.items]
	);

	return {
		...section,
		items: modifiedItems
	};
};
